// import {Panzoom as PanzoomLegacy} from 'panzoom';
import Panzoom from '@panzoom/panzoom'
import { Plan, PlanProduct } from './plan.js';

// export default class Plan2D extends Plan{
export default class Plan2D{
	constructor(planService){
		this.node = document.querySelector('.cmz-spot-plan2d');
		this.svg = this.node.querySelector('svg');
		this.type = CMZ.selector.settings?.plan2d_type || 'classic';
		
		this.settings = { // computed automatically
			minScale: 0,
			maxScale: 0,
			ratio: '',
		};

		this.products = [];

		const report = {
			'match': [],
			'missmatch': [],
		};

		// Create 2D product
		planService.products.forEach(planProduct => {
			const node = this.svg.querySelector(':scope [id^="unit-' + planProduct.id + '"]');
			
			const reportLine = {id: planProduct.id, db: true, plan: false};
			
			if (node){
				const product2D = new Plan2D_Product(node, planProduct);
				
				// Add interactions
				product2D.node.addEventListener('mouseenter', () => {
					planService.setInteraction('hover', planProduct);
				});
				
				product2D.node.addEventListener('mouseleave', () => {
					planService.setInteraction('hover', null);
				});

				// Attach to Plan2D
				this.products.push(product2D);

				// Attach to PlanProduct
				planProduct.product2D = product2D;

				report.match.push({...reportLine, plan: true});
			}
			else{
				report.missmatch.push({...reportLine, plan: false});
			}
		});

		console.log('Plan 2D', report);
	}

	initialize(){
		if (this.initialized) return;
		
		this.initialized = true;

		this.computeSettings();
		// window.addEventListener('resize', this.computeSettings.bind(this));

		// Change svg size if viewport ratio changes
		// window.addEventListener('resize', this.computeDimensions.bind(this));
		// this.computeDimensions();

		// let initialScale = 1;
		
		// // Compute min scale for render type plans
		// if (this.type == 'render'){
		// 	const bounding = this.svg.getBoundingClientRect();
		// 	const axis = bounding.y > bounding.left ? 'y' : 'x';
		// 	initialScale = 1 + ((bounding[axis] * 2) / (axis == 'y' ? bounding.height : bounding.width));
		// }

		// https://www.npmjs.com/package/@panzoom/panzoom
		this.panzoom = Panzoom(this.node, {
			// minScale: initialScale,
			// maxScale: Math.max(initialScale, (CMZ.selector.settings?.plan2d_maxscale || 2)),
			minScale: this.settings.minScale,
			maxScale: this.settings.maxScale,
			animate: true,
			duration: 300,
			contain: "outside",
			easing: 'ease-in-out',
			cursor: 'default',
			// canvas: true,
			// panOnlyWhenZoomed: true,
			handleStartEvent: (e) => {
			},
		});


		// this.panzoom.constrainXY = (toX, toY, toScale, panOptions) => {
		// 	const opts = { ...options, ...panOptions }
		// 	const result = { x, y, opts }

		// 	console.log('Hi');
			
		// 	if (
		// 	!panOptions?.force &&
		// 	(opts.disablePan || (opts.panOnlyWhenZoomed && scale === opts.startScale))
		// 	) {
		// 		return result
		// 	}
			
		// 	toX = parseFloat(toX);
		// 	toY = parseFloat(toY);

		// 	if (!opts.disableXAxis) {
		// 		result.x = (opts.relative ? x : 0) + toX
		// 	}

		// 	if (!opts.disableYAxis) {
		// 		result.y = (opts.relative ? y : 0) + toY
		// 	}

		// 	if (opts.contain) {
		// 		const dims = getDimensions(elem)
		// 		const realWidth = dims.elem.width / scale
		// 		const realHeight = dims.elem.height / scale
		// 		const scaledWidth = realWidth * toScale
		// 		const scaledHeight = realHeight * toScale
		// 		const diffHorizontal = (scaledWidth - realWidth) / 2
		// 		const diffVertical = (scaledHeight - realHeight) / 2

		// 		if (opts.contain === 'inside') {
		// 			const minX = (-dims.elem.margin.left - dims.parent.padding.left + diffHorizontal) / toScale
		// 			const maxX =
		// 			(dims.parent.width -
		// 				scaledWidth -
		// 				dims.parent.padding.left -
		// 				dims.elem.margin.left -
		// 				dims.parent.border.left -
		// 				dims.parent.border.right +
		// 				diffHorizontal) /
		// 			toScale
		// 			result.x = Math.max(Math.min(result.x, maxX), minX)
		// 			const minY = (-dims.elem.margin.top - dims.parent.padding.top + diffVertical) / toScale
		// 			const maxY =
		// 			(dims.parent.height -
		// 				scaledHeight -
		// 				dims.parent.padding.top -
		// 				dims.elem.margin.top -
		// 				dims.parent.border.top -
		// 				dims.parent.border.bottom +
		// 				diffVertical) /
		// 			toScale
		// 			result.y = Math.max(Math.min(result.y, maxY), minY)
		// 		} else if (opts.contain === 'outside') {
		// 			const minX =
		// 			(-(scaledWidth - dims.parent.width) -
		// 				dims.parent.padding.left -
		// 				dims.parent.border.left -
		// 				dims.parent.border.right +
		// 				diffHorizontal) /
		// 			toScale
		// 			const maxX = (diffHorizontal - dims.parent.padding.left) / toScale
		// 			result.x = Math.max(Math.min(result.x, maxX), minX)
		// 			const minY =
		// 			(-(scaledHeight - dims.parent.height) -
		// 				dims.parent.padding.top -
		// 				dims.parent.border.top -
		// 				dims.parent.border.bottom +
		// 				diffVertical) /
		// 			toScale
		// 			const maxY = (diffVertical - dims.parent.padding.top) / toScale
		// 			result.y = Math.max(Math.min(result.y, maxY), minY)
		// 		}
		// 	}

		// 	if (opts.roundPixels) {
		// 		result.x = Math.round(result.x)
		// 		result.y = Math.round(result.y)
		// 	}

		// 	return result
		// }

		

		window.addEventListener('resize', () => {
			// Reset
			// this.panzoom.zoom(1, {animate: false, force: true});
			// this.panzoom.pan(0, 0, {animate: false, force: true});
			
			// Compute
			this.computeSettings();
			
			// Apply new settings
			this.panzoom.setOptions(this.settings);
			
			// Reset
			this.panzoom.zoom(this.settings.minScale, {animate: false});
			this.panzoom.pan(0, 0, {animate: false});
			// this.node.setAttribute('data-ratio', this.settings.ratio);
		});

		// Clamp pan events for render type
		if (this.type == 'render'){
			this.node.addEventListener('panzoompan', (e) => {
				this.clampPan();
			});
			
			this.node.addEventListener('panzoomzoom', () => {
				this.clampPan();
			});
		}

		// Center
		requestAnimationFrame(() => {
			this.panzoom.pan(0, 0, {animate: false});
		});
		

		// Panning and pinch zooming are bound automatically (unless disablePan is true).
		// There are several available methods for zooming
		// that can be bound on button clicks or mousewheel.
		// button.addEventListener('click', panzoom.zoomIn)
		
		// Zoom navigation
		this.node.parentElement.addEventListener('wheel', this.panzoom.zoomWithWheel);
		
		this.nav = {
			zoomIn: document.querySelector('.cmz-spot-plan2d-toolbar-zoomin'),
			zoomOut: document.querySelector('.cmz-spot-plan2d-toolbar-zoomout'),
			compass: document.querySelector('.cmz-spot-plan2d-toolbar-compass')
		}
		
		this.nav.zoomIn.addEventListener('click', this.panzoom.zoomIn);
		this.nav.zoomOut.addEventListener('click', this.panzoom.zoomOut);
		this.nav.compass.addEventListener('click', this.panzoom.reset);
		// this.node.parentElement.addEventListener('click', panzoom.zoomIn)

		
		// this.node.addEventListener('panzoompan', e => {console.log(e.detail)});
		this.node.addEventListener('panzoomzoom', this.onScaleChange.bind(this));
		this.node.addEventListener('panzoomreset', this.onScaleChange.bind(this));

		// Create products
		this.products.forEach(product => {
			product.init(this.svg);
			// product.setTipPosition(this.svg);
		});
		
		// Attched product
		document.dispatchEvent(new CustomEvent('cmzSpotPlan2DLoaded', {detail: {plan: this}}));

		this.node.classList.add('is-ready');
	}

	clampPan() {
		const current = this.panzoom.getPan();
		const scale = this.panzoom.getScale();
		
		const b = this.svg.getBoundingClientRect();

		// Get maximum pan margin overflow
		const overflowMax = {
			x: Math.round(Math.abs((b.width - window.innerWidth) / 2) / scale),
			y: Math.round(Math.abs((b.height - window.innerHeight) / 2) / scale),
		};
		
		// Clamp current with max overflow
		const clamped = {
			x: Math.max(overflowMax.x * -1, Math.min(overflowMax.x, current.x)),
			y: Math.max(overflowMax.y * -1, Math.min(overflowMax.y, current.y)),
		};

		// Pan with clamped value if different from current
		if (current.x != clamped.x || current.y != clamped.y){
			this.panzoom.pan(clamped.x, clamped.y, {animate: true});
		}
	}

	onScaleChange(e){
		// Scale product tips relative to zoom
		this.node.style.setProperty('--scale', e.detail.scale);

		// console.log(e.detail.scale);
		
		// Update zoom buttons
		const options = this.panzoom.getOptions();
		const current = Math.round(e.detail.scale * 1000) / 1000;
		current >= options.maxScale ? this.nav.zoomIn.setAttribute('disabled', 'true') : this.nav.zoomIn.removeAttribute('disabled');
		current <= options.minScale ? this.nav.zoomOut.setAttribute('disabled', 'true') : this.nav.zoomOut.removeAttribute('disabled');
	}

	// updateRatio(){
	// 	const pageRatio = window.innerWidth / window.innerHeight;
	// 	const svgRatio = this.svg.viewBox.baseVal.width / this.svg.viewBox.baseVal.height;
		
	// 	this.node.setAttribute('data-ratio', (svgRatio > pageRatio ? 'horizontal' : 'vertical'));
	// }

	computeSettings(){
		// Update ratio
		const pageRatio = window.innerWidth / window.innerHeight;
		const svgRatio = this.svg.viewBox.baseVal.width / this.svg.viewBox.baseVal.height;
		this.settings.ratio = svgRatio > pageRatio ? 'horizontal' : 'vertical';
		this.node.setAttribute('data-ratio', this.settings.ratio);
		
		// Reset min/max scale
		this.settings.minScale = 1;
		this.settings.maxScale = CMZ.selector.settings?.plan2d_maxscale || 2;
		
		if (this.type == 'render'){
			let coef, diff, scale;

			if (this.settings.ratio == 'vertical'){
				// Get difference between SVG size and window size on the maxed out axis
				coef = window.innerWidth / this.svg.viewBox.baseVal.width;

				// Apply difference to the other axis
				diff = this.svg.viewBox.baseVal.height * coef;
				
				// Determine scale to fill in space between svg and windows on the other axis
				scale = diff / window.innerHeight;
			}
			else{
				// Get difference between SVG size and window size on the maxed out axis
				coef = window.innerHeight / this.svg.viewBox.baseVal.height;

				// Apply difference to the other axis
				diff = this.svg.viewBox.baseVal.width * coef;
				
				// Determine scale to fill in space between svg and windows on the other axis
				scale = diff / window.innerWidth;
			}

			// Set minimun scale so that it never bleed
			this.settings.minScale = scale;
			
			// Increase max scale if min is higher (no zoom) -> do max = min +1 to make sure it is always zoomable?
			this.settings.maxScale = Math.max((this.settings.minScale + 1.5), this.settings.maxScale);
		}

		console.log(this.settings);
	}

	// computeDimensions(){
	// 	// Update ratio
	// 	this.updateRatio();

	// 	// Compute scale
	// 	const scale = {
	// 		min: 1,
	// 		max: CMZ.selector.settings?.plan2d_maxscale || 2,
	// 	}

	// 	if (this.type == 'render'){
	// 		const bounding = this.svg.getBoundingClientRect();
	// 		const axis = bounding.y > bounding.left ? 'y' : 'x';
	// 		// Set minimun scale so that it never bleed
	// 		scale.min = 1 + ((bounding[axis] * 2) / (axis == 'y' ? bounding.height : bounding.width));
			
	// 		// Increase max scale if min is higher (no zoom) -> do max = min +1 to make sure it is always zoomable?
	// 		scale.max = Math.max(scale.min, scale.max);
	// 	}
	// }

	getProduct(id){
		return this.products.find(product => product.id == id);
	}

	getFloorNode(id){
		return this.svg.querySelector(':scope [id^="floor-' + id + '"]');
	}

	panTo(node){
		const scale = this.panzoom.getScale();
		const b = node.getBoundingClientRect();
		// const leftCenter = window.innerWidth > .75 ? : .5;
		const productPopupWidth = window.innerWidth >= 1024 ? 400 : 0;
		
		const productCenter = {
			x: b.left + b.width * .5,
			y: b.top + b.height * .5,
		}

		const windowCenter = {
			x: (window.innerWidth + (productPopupWidth / 2)) * .5,
			y: window.innerHeight * .5,
		};

		const difference = {
			x: ((productCenter.x - windowCenter.x) / scale) * -1,
			y: ((productCenter.y - windowCenter.y) / scale) * -1,
		};

		this.panzoom.pan(difference.x, difference.y, {relative: true});
	}

	panToProduct(product){
		if (this.initialized){
			this.panTo(product.anchor || product.node);
		}
	}

	/*
	afterProductOpened(planProduct, floorService){
		if (!planProduct?.product2D) return;

		// Center product
		this.panTo(planProduct.product2D.node);

		floorService.moveToProduct(planProduct);

	}

	afterProductFocused(planProduct, floorService){
		if (!planProduct?.product2D) return;

		// Center product
		this.panTo(planProduct.product2D.node);
	}
	*/
}

// class Plan2D_Product extends PlanProduct{
class Plan2D_Product{
	constructor(node, planProduct){
		// string this.id
		// string this.details
		// object this.states
		// super(node.id.replace('product-', ''));
		// this.id = node.id.replace('product-', '');
		this.id = planProduct.id;
		this.node = node;
		this.tip = document.querySelector('.cmz-spot-plan2d-icetip[data-id="' + this.id + '"]');
		this.anchor = document.querySelector('*[id^="anchor-' + this.id + '"]');
		this.origin = {x: 0, y: 0}

		// this.floor = floors.find(floor => {
		// 	return floor.id == node.parentNode.id.replace('floor-', '');
		// });

		// floorService.addProductToFloor(node.parentNode.id.replace('floor-', ''), product);


		// Attach product to floor
		// if (this.floor){
		// 	this.floor.addProduct(this);
		// }
		
		// this.exists = CMZ.products.find(product => product.id == this.id);
		
		// Set inital status
		this.node.setAttribute('data-status', planProduct.status);
		this?.tip?.setAttribute('data-status', planProduct.status);

		this.node.addEventListener('click', () => {
			// Scale up scope to then cascade down simultaniously to 2D and 3D Plans
			document.dispatchEvent(new CustomEvent('cmzPlanProductClicked', {detail: {productId: this.id}}));
		});
	}

	onStatusChange(){
		// this.node.setAttribute('data-status', this.status);
		// this?.tip?.setAttribute('data-status', this.status);
		// this?.floor?.updateState();
	}

	// onStateChange(){
	updateState(states){
		// console.log(states);
		
		if (states.filtered){
			this.node.setAttribute('data-state', 'filtered');
			this?.tip?.setAttribute('data-state', 'filtered');
		}
		else if (states.hover){
			this.node.setAttribute('data-state', 'hover');
			this?.tip?.setAttribute('data-state', 'hover');
		}
		else if (states.open){
			this.node.setAttribute('data-state', 'open');
			this?.tip?.setAttribute('data-state', 'open');
		}
		else if (states.focus){
			this.node.setAttribute('data-state', 'focus');
			this?.tip?.setAttribute('data-state', 'focus');
		}
		else{
			this.node.removeAttribute('data-state');
			this?.tip?.removeAttribute('data-state');
		}

		// Update floor status
		this.floor?.updateState();
	}

	init(svg){
		// Compute origin
		const bbox = this.anchor ? this.anchor.getBBox() : this.node.getBBox();

		const origin = {
			x: bbox.x + (bbox.width / 2),
			y: bbox.y + (bbox.height / 2),
		};

		// Set tip position
		if (this.tip){		
			this.tip.style.setProperty('--x', (origin.x / svg.viewBox.baseVal.width) * 100 + '%');
			this.tip.style.setProperty('--y', (origin.y / svg.viewBox.baseVal.height) * 100 + '%');
		}
	}
}